import type { PlatformId, PlatformLimits } from "@/types/platforms";
import { PLATFORM_LIMITS } from "./limits";

export const PLATFORM_REGISTRY: Record<
  PlatformId,
  PlatformLimits & {
    label: string;
    color: string;
    publishingImplemented: boolean;
  }
> = {
  youtube: {
    label: "YouTube",
    color: "#FF0000",
    publishingImplemented: true,
    ...PLATFORM_LIMITS.youtube,
  },
  tiktok: {
    label: "TikTok",
    color: "#000000",
    publishingImplemented: true,
    ...PLATFORM_LIMITS.tiktok,
  },
  instagram: {
    label: "Instagram",
    color: "#E4405F",
    publishingImplemented: true,
    ...PLATFORM_LIMITS.instagram,
  },
  facebook: {
    label: "Facebook",
    color: "#1877F2",
    publishingImplemented: true,
    ...PLATFORM_LIMITS.facebook,
  },
  linkedin: {
    label: "LinkedIn",
    color: "#0A66C2",
    publishingImplemented: true,
    ...PLATFORM_LIMITS.linkedin,
  },
  x: {
    label: "X",
    color: "#000000",
    publishingImplemented: true,
    ...PLATFORM_LIMITS.x,
  },
};
